import I18n from 'I18n';
export const industryOptions = () => [{
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ACCOUNTING'),
  value: 'ACCOUNTING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.AIRLINES_AND_AVIATION'),
  value: 'AIRLINES_AND_AVIATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ALTERNATIVE_DISPUTE_RESOLUTION'),
  value: 'ALTERNATIVE_DISPUTE_RESOLUTION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ALTERNATIVE_MEDICINE'),
  value: 'ALTERNATIVE_MEDICINE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ANIMATION'),
  value: 'ANIMATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.APPAREL_AND_FASHION'),
  value: 'APPAREL_AND_FASHION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ARCHITECTURE_AND_PLANNING'),
  value: 'ARCHITECTURE_AND_PLANNING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ARTS_AND_CRAFTS'),
  value: 'ARTS_AND_CRAFTS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.AUTOMOTIVE'),
  value: 'AUTOMOTIVE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.AVIATION_AND_AEROSPACE'),
  value: 'AVIATION_AND_AEROSPACE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.BANKING'),
  value: 'BANKING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.BIOTECHNOLOGY'),
  value: 'BIOTECHNOLOGY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.BROADCAST_MEDIA'),
  value: 'BROADCAST_MEDIA'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.BUILDING_MATERIALS'),
  value: 'BUILDING_MATERIALS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.BUSINESS_SUPPLIES_AND_EQUIPMENT'),
  value: 'BUSINESS_SUPPLIES_AND_EQUIPMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CAPITAL_MARKETS'),
  value: 'CAPITAL_MARKETS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CHEMICALS'),
  value: 'CHEMICALS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CIVIC_AND_SOCIAL_ORGANIZATION'),
  value: 'CIVIC_AND_SOCIAL_ORGANIZATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CIVIL_ENGINEERING'),
  value: 'CIVIL_ENGINEERING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMMERCIAL_REAL_ESTATE'),
  value: 'COMMERCIAL_REAL_ESTATE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMPUTER_AND_NETWORK_SECURITY'),
  value: 'COMPUTER_AND_NETWORK_SECURITY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMPUTER_GAMES'),
  value: 'COMPUTER_GAMES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMPUTER_HARDWARE'),
  value: 'COMPUTER_HARDWARE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMPUTER_NETWORKING'),
  value: 'COMPUTER_NETWORKING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COMPUTER_SOFTWARE'),
  value: 'COMPUTER_SOFTWARE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CONSTRUCTION'),
  value: 'CONSTRUCTION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CONSUMER_ELECTRONICS'),
  value: 'CONSUMER_ELECTRONICS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CONSUMER_GOODS'),
  value: 'CONSUMER_GOODS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.CONSUMER_SERVICES'),
  value: 'CONSUMER_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.COSMETICS'),
  value: 'COSMETICS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.DAIRY'),
  value: 'DAIRY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.DEFENSE_AND_SPACE'),
  value: 'DEFENSE_AND_SPACE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.DESIGN'),
  value: 'DESIGN'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.E_LEARNING'),
  value: 'E_LEARNING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.EDUCATION_MANAGEMENT'),
  value: 'EDUCATION_MANAGEMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ELECTRICAL_ELECTRONIC_MANUFACTURING'),
  value: 'ELECTRICAL_ELECTRONIC_MANUFACTURING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ENTERTAINMENT'),
  value: 'ENTERTAINMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ENVIRONMENTAL_SERVICES'),
  value: 'ENVIRONMENTAL_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.EVENTS_SERVICES'),
  value: 'EVENTS_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.EXECUTIVE_OFFICE'),
  value: 'EXECUTIVE_OFFICE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FACILITIES_SERVICES'),
  value: 'FACILITIES_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FARMING'),
  value: 'FARMING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FINANCIAL_SERVICES'),
  value: 'FINANCIAL_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FINE_ART'),
  value: 'FINE_ART'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FISHERY'),
  value: 'FISHERY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FOOD_AND_BEVERAGES'),
  value: 'FOOD_AND_BEVERAGES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FOOD_PRODUCTION'),
  value: 'FOOD_PRODUCTION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FUND_RAISING'),
  value: 'FUND_RAISING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.FURNITURE'),
  value: 'FURNITURE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.GAMBLING_AND_CASINOS'),
  value: 'GAMBLING_AND_CASINOS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.GLASS_CERAMICS_AND_CONCRETE'),
  value: 'GLASS_CERAMICS_AND_CONCRETE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.GOVERNMENT_ADMINISTRATION'),
  value: 'GOVERNMENT_ADMINISTRATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.GOVERNMENT_RELATIONS'),
  value: 'GOVERNMENT_RELATIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.GRAPHIC_DESIGN'),
  value: 'GRAPHIC_DESIGN'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.HEALTH_WELLNESS_AND_FITNESS'),
  value: 'HEALTH_WELLNESS_AND_FITNESS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.HIGHER_EDUCATION'),
  value: 'HIGHER_EDUCATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.HOSPITAL_AND_HEALTH_CARE'),
  value: 'HOSPITAL_AND_HEALTH_CARE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.HOSPITALITY'),
  value: 'HOSPITALITY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.HUMAN_RESOURCES'),
  value: 'HUMAN_RESOURCES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.IMPORT_AND_EXPORT'),
  value: 'IMPORT_AND_EXPORT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INDIVIDUAL_AND_FAMILY_SERVICES'),
  value: 'INDIVIDUAL_AND_FAMILY_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INDUSTRIAL_AUTOMATION'),
  value: 'INDUSTRIAL_AUTOMATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INFORMATION_SERVICES'),
  value: 'INFORMATION_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INFORMATION_TECHNOLOGY_AND_SERVICES'),
  value: 'INFORMATION_TECHNOLOGY_AND_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INSURANCE'),
  value: 'INSURANCE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INTERNATIONAL_AFFAIRS'),
  value: 'INTERNATIONAL_AFFAIRS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INTERNATIONAL_TRADE_AND_DEVELOPMENT'),
  value: 'INTERNATIONAL_TRADE_AND_DEVELOPMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INTERNET'),
  value: 'INTERNET'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INVESTMENT_BANKING'),
  value: 'INVESTMENT_BANKING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.INVESTMENT_MANAGEMENT'),
  value: 'INVESTMENT_MANAGEMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.JUDICIARY'),
  value: 'JUDICIARY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LAW_ENFORCEMENT'),
  value: 'LAW_ENFORCEMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LAW_PRACTICE'),
  value: 'LAW_PRACTICE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LEGAL_SERVICES'),
  value: 'LEGAL_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LEGISLATIVE_OFFICE'),
  value: 'LEGISLATIVE_OFFICE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LEISURE_TRAVEL_AND_TOURISM'),
  value: 'LEISURE_TRAVEL_AND_TOURISM'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LIBRARIES'),
  value: 'LIBRARIES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LOGISTICS_AND_SUPPLY_CHAIN'),
  value: 'LOGISTICS_AND_SUPPLY_CHAIN'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.LUXURY_GOODS_AND_JEWELRY'),
  value: 'LUXURY_GOODS_AND_JEWELRY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MACHINERY'),
  value: 'MACHINERY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MANAGEMENT_CONSULTING'),
  value: 'MANAGEMENT_CONSULTING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MARITIME'),
  value: 'MARITIME'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MARKET_RESEARCH'),
  value: 'MARKET_RESEARCH'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MARKETING_AND_ADVERTISING'),
  value: 'MARKETING_AND_ADVERTISING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MECHANICAL_OR_INDUSTRIAL_ENGINEERING'),
  value: 'MECHANICAL_OR_INDUSTRIAL_ENGINEERING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MEDIA_PRODUCTION'),
  value: 'MEDIA_PRODUCTION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MEDICAL_DEVICES'),
  value: 'MEDICAL_DEVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MEDICAL_PRACTICE'),
  value: 'MEDICAL_PRACTICE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MENTAL_HEALTH_CARE'),
  value: 'MENTAL_HEALTH_CARE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MILITARY'),
  value: 'MILITARY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MINING_AND_METALS'),
  value: 'MINING_AND_METALS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MOTION_PICTURES_AND_FILM'),
  value: 'MOTION_PICTURES_AND_FILM'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MUSEUMS_AND_INSTITUTIONS'),
  value: 'MUSEUMS_AND_INSTITUTIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.MUSIC'),
  value: 'MUSIC'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.NANOTECHNOLOGY'),
  value: 'NANOTECHNOLOGY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.NEWSPAPERS'),
  value: 'NEWSPAPERS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.NON_PROFIT_ORGANIZATION_MANAGEMENT'),
  value: 'NON_PROFIT_ORGANIZATION_MANAGEMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.OIL_AND_ENERGY'),
  value: 'OIL_AND_ENERGY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.ONLINE_MEDIA'),
  value: 'ONLINE_MEDIA'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.OUTSOURCING_OFFSHORING'),
  value: 'OUTSOURCING_OFFSHORING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PACKAGE_FREIGHT_DELIVERY'),
  value: 'PACKAGE_FREIGHT_DELIVERY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PACKAGING_AND_CONTAINERS'),
  value: 'PACKAGING_AND_CONTAINERS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PAPER_AND_FOREST_PRODUCTS'),
  value: 'PAPER_AND_FOREST_PRODUCTS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PERFORMING_ARTS'),
  value: 'PERFORMING_ARTS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PHARMACEUTICALS'),
  value: 'PHARMACEUTICALS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PHILANTHROPY'),
  value: 'PHILANTHROPY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PHOTOGRAPHY'),
  value: 'PHOTOGRAPHY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PLASTICS'),
  value: 'PLASTICS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.POLITICAL_ORGANIZATION'),
  value: 'POLITICAL_ORGANIZATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PRIMARY_SECONDARY_EDUCATION'),
  value: 'PRIMARY_SECONDARY_EDUCATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PRINTING'),
  value: 'PRINTING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PROFESSIONAL_TRAINING_AND_COACHING'),
  value: 'PROFESSIONAL_TRAINING_AND_COACHING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PROGRAM_DEVELOPMENT'),
  value: 'PROGRAM_DEVELOPMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PUBLIC_POLICY'),
  value: 'PUBLIC_POLICY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PUBLIC_RELATIONS_AND_COMMUNICATIONS'),
  value: 'PUBLIC_RELATIONS_AND_COMMUNICATIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PUBLIC_SAFETY'),
  value: 'PUBLIC_SAFETY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.PUBLISHING'),
  value: 'PUBLISHING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RAILROAD_MANUFACTURE'),
  value: 'RAILROAD_MANUFACTURE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RANCHING'),
  value: 'RANCHING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.REAL_ESTATE'),
  value: 'REAL_ESTATE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RECREATIONAL_FACILITIES_AND_SERVICES'),
  value: 'RECREATIONAL_FACILITIES_AND_SERVICES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RELIGIOUS_INSTITUTIONS'),
  value: 'RELIGIOUS_INSTITUTIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RENEWABLES_AND_ENVIRONMENT'),
  value: 'RENEWABLES_AND_ENVIRONMENT'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RESEARCH'),
  value: 'RESEARCH'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RESTAURANTS'),
  value: 'RESTAURANTS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.RETAIL'),
  value: 'RETAIL'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SECURITY_AND_INVESTIGATIONS'),
  value: 'SECURITY_AND_INVESTIGATIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SEMICONDUCTORS'),
  value: 'SEMICONDUCTORS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SHIPBUILDING'),
  value: 'SHIPBUILDING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SPORTING_GOODS'),
  value: 'SPORTING_GOODS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SPORTS'),
  value: 'SPORTS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.STAFFING_AND_RECRUITING'),
  value: 'STAFFING_AND_RECRUITING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.SUPERMARKETS'),
  value: 'SUPERMARKETS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.TELECOMMUNICATIONS'),
  value: 'TELECOMMUNICATIONS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.TEXTILES'),
  value: 'TEXTILES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.THINK_TANKS'),
  value: 'THINK_TANKS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.TOBACCO'),
  value: 'TOBACCO'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.TRANSLATION_AND_LOCALIZATION'),
  value: 'TRANSLATION_AND_LOCALIZATION'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.TRANSPORTATION_AND_TRUCKING_AND_RAILROAD'),
  value: 'TRANSPORTATION_AND_TRUCKING_AND_RAILROAD'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.UTILITIES'),
  value: 'UTILITIES'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.VENTURE_CAPITAL_AND_PRIVATE_EQUITY'),
  value: 'VENTURE_CAPITAL_AND_PRIVATE_EQUITY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.VETERINARY'),
  value: 'VETERINARY'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.WAREHOUSING'),
  value: 'WAREHOUSING'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.WHOLESALE'),
  value: 'WHOLESALE'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.WINE_AND_SPIRITS'),
  value: 'WINE_AND_SPIRITS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.WIRELESS'),
  value: 'WIRELESS'
}, {
  text: I18n.text('profilePage.editProfile.personalDetails.industry.options.WRITING_AND_EDITING'),
  value: 'WRITING_AND_EDITING'
}];